import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import InfoIcon from '@material-ui/icons/Info';
import PacoteRegisterInfo from './components/PacoteRegisterInfo';
import Box from '@material-ui/core/Box';
import PacoteToolbar from './components/PacoteRegisterToolbar';
import AppBar from '@material-ui/core/AppBar';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import { MessageValues } from '../../values/MessageValues';
import { isAuthenticated } from '../../helpers/authenticate';
import { ValidatorForm } from 'react-material-ui-form-validator';

const timeout = ServiceValues.timeout;

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    marginRight: theme.spacing(3),
    marginLeft: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
  },
  toolbar: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3)
  }
}));
function PacoteRegister({history}) {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [pacote, setPacote] = useState(history.location.state.pacote);
  const [edicao, setEdicao] = useState(history.location.state.edicao);
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [value, setValue] = React.useState(0);

  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        {...other}
      >
        <Box
          p={3}
        >
          {children}
        </Box>
      </Typography>
    );
  }

  function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
  }

  async function savePacote() {
    if(edicao){
      try{
        setLoading(true);
        const baseUrl = ServiceValues.base_url_local;
        const api = ServiceAxios(baseUrl, timeout);
        const pacote_post = {
          descricao: pacote.descricao,
          valor: pacote.valor,
          acrescimosCartao: pacote.acrescimosCartao,
          valorVendaCartao: pacote.valorVendaCartao,
          quantidadeDisparos: pacote.quantidadeDisparos,
          armas: pacote.armas
        };
        const dados = await api.put(`pacotes/${pacote.idPacote}`, pacote_post);
        if(dados.data.isSuccess){
          setMessageSnack(dados.data.message);
          setTypeSnack('success');
          setShowMessageSnack(true);
          history.push('/pacote-list/');
        }
        else{
          setMessageSnack(dados.data.message);
          setTypeSnack('error');
          setShowMessageSnack(true);
        }
        setLoading(false);
      }
      catch (e) {
        setLoading(false);
        setMessageSnack(MessageValues.erro_catch);
        setTypeSnack('error');
        setShowMessageSnack(true);
      }
    }
    else{
      try{
        setLoading(true);
        const baseUrl = ServiceValues.base_url_local;
        const api = ServiceAxios(baseUrl, timeout);
        const pacote_post = {
          descricao: pacote.descricao,
          valor: pacote.valor,
          acrescimosCartao: pacote.acrescimosCartao,
          valorVendaCartao: pacote.valorVendaCartao,
          quantidadeDisparos: pacote.quantidadeDisparos,
          armas: pacote.armas
        };
        const dados = await api.post('pacotes/', pacote_post);
        if(dados.data.isSuccess){
          setMessageSnack(dados.data.message);
          setTypeSnack('success');
          setShowMessageSnack(true);
          history.push('/pacote-list/');
        }
        else{
          setMessageSnack(dados.data.message);
          setTypeSnack('error');
          setShowMessageSnack(true);
        }
        setLoading(false);
      }
      catch (e) {
        setLoading(false);
        setMessageSnack('Falha de comunicação. Contate o suporte!');
        setTypeSnack('error');
        setShowMessageSnack(true);
      }
    }
  }


  return (
    <ValidatorForm
      autoComplete="off"
      onSubmit={savePacote}
    >
      <div>
        <ProgressFullScreen
          open={loading}
          setOpen={setLoading}
        />
        <SnackbarCustom
          verticalOrientation='bottom'
          horizontalOrientation='center'
          open={showMessageSnack}
          setOpen={setShowMessageSnack}
          message={messageSnack}
          duration={2000}
          type={typeSnack}
        />
        <PacoteToolbar
          className={classes.toolbar}
          savePacote={savePacote}
          history={history}
        />
        <Paper className={classes.root}>
          <AppBar position="static" color="inherit">

            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              <Tab label="Informações Gerais" icon={<InfoIcon />} {...a11yProps(0)} />
            </Tabs>
          </AppBar>
          <TabPanel value={value} index={0}>
            <PacoteRegisterInfo
              pacote={pacote}
              setPacote={setPacote}
              setShowMessageSnack={setShowMessageSnack}
              setTypeSnack={setTypeSnack}
              setMessageSnack={setMessageSnack}
              edicao={edicao}
            />
          </TabPanel>
        </Paper>
      </div>
    </ValidatorForm>

  );
};

export default PacoteRegister;
